import { render, staticRenderFns } from "./Company-Settings.vue?vue&type=template&id=71f1cb63&scoped=true&"
import script from "./Company-Settings.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Company-Settings.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Company-Settings.vue?vue&type=style&index=0&id=71f1cb63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1cb63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VContainer,VFlex,VImg,VLayout,VTooltip})
